<template>
    <div id="supervisor-dci">

        <b-modal hide-footer size="sm" ref="dci-modal" title="DCI">
            <b-row>

                <!-- <b-col cols="12">
                    <b-form-group label="DCI Code">
                        <b-form-input v-model="dci.code" placeholder="DCI Code" ref="dciCode" @keyup.enter="saveData" />
                    </b-form-group>
                </b-col> -->

                <b-col cols="12">
                    <b-form-group label="DCI Description">
                        <b-form-input v-model="dci.description" placeholder="DCI Description" @keyup.enter="saveData" />
                    </b-form-group>
                </b-col>

            </b-row>

            <b-row class="text-right">

                <b-col cols="12" md="12">
                    <b-button @click="saveData()" variant="relief-success">
                        <feather-icon icon="PocketIcon" class="mr-50" />
                        <span class="align-middle">Save</span>
                    </b-button>
                </b-col>

            </b-row>

        </b-modal>

        <b-overlay :show="showLoading" spinner-variant="primary">
            <b-card>
                <ag-grid :agGrid="agGrid" pageTitle="DCI List" @refresh="loadData" :add="true" @plusClicked="showModal" />
            </b-card>
        </b-overlay>

    </div>
</template>

<script>
import AgGrid from "@/views/components/ag-grid/AgGrid.vue"
import ButtonCellRenderer from "@/views/components/ag-grid/ButtonCellRenderer.vue"

export default {
    components: {
        AgGrid,
    },
    data() {
        return {
            showLoading: false,
            agGrid: {
                columnDefs: [
                    {
                        headerName: "Code",
                        field: "code",
                    },
                    {
                        headerName: "Description",
                        field: "description",
                    },
                    {
                        sortable: false,
                        resizable: false,
                        filter: false,
                        headerName: '',
                        cellClass: 'centered-customeCellRender',
                        cellRendererFramework: 'buttonCellRenderer',
                        cellRendererParams: { onButtonClick: this.showModal, icon: "read_more" },
                        width: 100
                    },
                ],
                rows: []
            },
            dci: {
                id: "",
                code: "",
                description: ""
            },
        }
    },
    created() {
        this.$options.components.buttonCellRenderer = ButtonCellRenderer;
        this.loadData();
    },
    methods: {
        showModal(data) {
            if (data == undefined) {
                this.dci = {
                    id: "",
                    code: "",
                    description: ""
                }
            } else {
                this.dci = {
                    id: data.id,
                    code: data.code,
                    description: data.description
                }
            }
            this.$refs['dci-modal'].show();
            setTimeout(() => {
                this.$refs["dciCode"].focus();
            }, 400);
        },
        async saveData() {
            this.$refs['dci-modal'].hide();
            this.showLoading = true;
            let response = await this.$http.post("_item/dci", this.dci).catch(() => this.showLoading = false);
            this.agGrid.rows = response.data;
            this.showLoading = false;
        },
        async loadData() {
            this.showLoading = true;
            let response = await this.$http.get("_item/dci").catch(() => this.showLoading = false);
            this.agGrid.rows = response.data;
            this.showLoading = false;
        }
    },
}
</script>
<style lang="scss" scoped></style>